'use client';

import {
  StoryblokServerComponent,
  storyblokEditable,
} from '@storyblok/react/rsc';
import { FC } from 'react';
import { MagazineTeasersStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Slide } from 'atoms/Carousel';
import { Container } from 'atoms/Container';
import { Slider } from 'molecules/Slider';
import { IServerProps } from 'pages/StoryBlok/types';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const MagazineTeasersList: FC<{
  blok?: MagazineTeasersStoryblok;
  serverProps: IServerProps;
}> = ({ blok }) => {
  const { isSmallDesktop } = useMediaQuery();

  if (!blok || blok.disableForLocale) {
    return null;
  }

  const link = blok?.link?.[0];

  return (
    <Container className={styles.root} {...storyblokEditable(blok)}>
      {isSmallDesktop ? (
        <div className={styles.teasersList}>
          {blok.teasers?.map((teaser) => (
            <StoryblokServerComponent key={teaser._uid} blok={teaser} />
          ))}
        </div>
      ) : (
        <Slider
          slidesPerView="auto"
          spaceBetween={10}
          pagination={{
            enabled: true,
          }}
        >
          {blok.teasers?.map((teaser) => (
            <Slide key={teaser._uid} className={styles.slide}>
              <StoryblokServerComponent blok={teaser} />
            </Slide>
          ))}
        </Slider>
      )}
      {link && (
        <Button href={link.parameters?.url} className={styles.button}>
          {link?.text}
        </Button>
      )}
    </Container>
  );
};
